(function () {
  "use strict";

  const BulkTitleImport = {
    initialBlankRows: 25,
    hot: null,
    hotIframe: null,
    hotMountElement: null,
    rowMeta: [],
    failedRowIds: [],
    lookups: {},
    pendingRowFetchTokens: {},
    bootstrapAttempts: 0,
    autoFetchTriggered: false,
    urlOptions: {
      prefillInput: "",
      autoFetch: false,
      iframeGrid: true,
    },

    init() {
      this.container = document.getElementById("bulk-title-import-container");
      if (!this.container) {
        return;
      }

      this.elements = {
        saveButton: document.getElementById("bulk-title-save-btn"),
        retryButton: document.getElementById("bulk-title-retry-btn"),
        status: document.getElementById("bulk-title-import-status"),
        alert: document.getElementById("bulk-title-import-alert"),
        summary: document.getElementById("bulk-title-hot-summary"),
        sessionId: document.getElementById("bulk-title-session-id"),
        hotContainer: document.getElementById("bulk-title-hot-container"),
        verifyContainer: document.getElementById("bulk-title-verify-container"),
        importStep: document.getElementById("bulk-title-import-step"),
        importSummary: document.getElementById("bulk-import-summary-panel"),
        wizardSteps: document.getElementById("bulk-wizard-steps"),
        wizardBack: document.getElementById("bulk-wizard-back"),
        wizardNext: document.getElementById("bulk-wizard-next"),
      };

      this.currentStep = 1;
      this.currentView = "spreadsheet";

      this.urlOptions = this.getUrlOptions();
      document.body.classList.add("bulk-title-import-page");
      if (this.urlOptions.iframeGrid) {
        document.body.classList.add("bulk-title-import-grid-iframe");
      }

      this.prepareHotHost();
      this.bindEvents();
      this.bootstrapGridWorkspaceWithRetries();

      if (window.BulkTitleVerifyPanel && this.elements.verifyContainer) {
        window.BulkTitleVerifyPanel.init(this.elements.verifyContainer);
      }
    },

    bindEvents() {
      if (this.elements.saveButton) {
        this.elements.saveButton.addEventListener("click", () => {
          this.saveRows(false);
        });
      }

      if (this.elements.retryButton) {
        this.elements.retryButton.addEventListener("click", () => {
          this.saveRows(true);
        });
      }

      if (this.elements.wizardBack) {
        this.elements.wizardBack.addEventListener("click", () => {
          this.goToStep(this.currentStep - 1);
        });
      }

      if (this.elements.wizardNext) {
        this.elements.wizardNext.addEventListener("click", () => {
          this.goToStep(this.currentStep + 1);
        });
      }

      // Allow clicking wizard step indicators to navigate
      if (this.elements.wizardSteps) {
        this.elements.wizardSteps.addEventListener("click", (e) => {
          const stepEl = e.target.closest(".wizard-step");
          if (stepEl && stepEl.dataset.step) {
            this.goToStep(parseInt(stepEl.dataset.step, 10));
          }
        });
      }

      window.addEventListener("resize", () => {
        this.syncGridHeight();
      });
    },

    getUrlOptions() {
      const params = new URLSearchParams(window.location.search || "");
      const prefillRaw =
        params.get("imdb_ids") ||
        params.get("imdb") ||
        params.get("prefill_imdb") ||
        "";
      const iframeParamValue =
        params.get("grid_iframe") !== null
          ? params.get("grid_iframe")
          : params.get("iframe_grid") !== null
          ? params.get("iframe_grid")
          : params.get("iframe");

      return {
        prefillInput: this.normalizePrefillInput(prefillRaw),
        autoFetch:
          this.isTruthyParam(params.get("autofetch")) ||
          this.isTruthyParam(params.get("auto_fetch")) ||
          this.isTruthyParam(params.get("fetch")),
        iframeGrid: this.parseBooleanParamWithDefault(iframeParamValue, true),
      };
    },

    isTruthyParam(value) {
      if (value === null || value === undefined) {
        return false;
      }

      const normalized = String(value).trim().toLowerCase();
      return (
        normalized === "1" ||
        normalized === "true" ||
        normalized === "yes" ||
        normalized === "on"
      );
    },

    parseBooleanParamWithDefault(value, defaultValue) {
      if (value === null || value === undefined) {
        return defaultValue;
      }

      const normalized = String(value).trim().toLowerCase();
      if (
        normalized === "1" ||
        normalized === "true" ||
        normalized === "yes" ||
        normalized === "on"
      ) {
        return true;
      }

      if (
        normalized === "0" ||
        normalized === "false" ||
        normalized === "no" ||
        normalized === "off"
      ) {
        return false;
      }

      return defaultValue;
    },

    normalizePrefillInput(rawValue) {
      if (!rawValue || typeof rawValue !== "string") {
        return "";
      }

      const tokens = rawValue
        .split(/[\s,]+/)
        .map((entry) => entry.trim())
        .filter((entry) => entry.length > 0);

      if (tokens.length === 0) {
        return "";
      }

      return tokens.join("\n");
    },

    applyUrlPrefillAndAutoFetch() {
      if (!this.urlOptions.prefillInput) {
        return;
      }

      const lines = this.parseLines(this.urlOptions.prefillInput);
      if (!this.hot || lines.length === 0) {
        return;
      }

      this.setImdbIdsIntoGridFromLines(lines, this.urlOptions.autoFetch);
    },

    isHandsontableReady() {
      return (
        !!window.Handsontable &&
        !!window.BulkTitleHotConfig &&
        !!this.hotMountElement
      );
    },

    bootstrapGridWorkspaceWithRetries() {
      this.bootstrapAttempts = 0;

      const attemptBootstrap = () => {
        this.bootstrapAttempts += 1;
        const bootstrapped = this.bootstrapGridWorkspace();

        if (bootstrapped) {
          this.applyUrlPrefillAndAutoFetch();
          return;
        }

        if (this.bootstrapAttempts >= 30) {
          this.showAlert(
            "Grid failed to initialize. Please reload this page.",
            "alert"
          );
          return;
        }

        window.setTimeout(attemptBootstrap, 120);
      };

      attemptBootstrap();
    },

    bootstrapGridWorkspace() {
      if (!this.isHandsontableReady()) {
        this.prepareHotHost();
        return false;
      }

      this.clearAlert();
      this.hideSummary();
      this.renderHandsontable(
        this.createBlankRows(this.initialBlankRows),
        this.lookups || {}
      );

      if (!this.hot) {
        return false;
      }

      this.setSaveEnabled(true);
      this.primeLookups();
      return true;
    },

    async primeLookups() {
      try {
        const response = await fetch("/api/admin/bulk-titles/preview", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ identifiers: [] }),
        });
        const payload = await response.json();
        if (!response.ok || !payload.success) {
          return;
        }

        const data = payload.data || {};
        if (data.lookups && Object.keys(data.lookups).length > 0) {
          this.setLookups(data.lookups);
        }
      } catch (error) {
        this.setLoading(false, "");
      }
    },

    setLookups(lookups) {
      if (!lookups || typeof lookups !== "object") {
        return;
      }

      this.lookups = lookups;

      if (!this.hot || !window.BulkTitleHotConfig) {
        return;
      }

      const columns = window.BulkTitleHotConfig.createColumns(this.lookups);
      this.hot.updateSettings({ columns });
      this.hot.render();
    },

    createBlankFieldSet() {
      const fields =
        window.BulkTitleHotConfig && window.BulkTitleHotConfig.createDataFields
          ? window.BulkTitleHotConfig.createDataFields()
          : [];
      const row = {};
      fields.forEach((field) => {
        if (field === "__row_status") {
          row[field] = "";
          return;
        }
        if (field === "__import_destination") {
          row[field] = "SD";
          return;
        }
        row[field] = null;
      });
      return row;
    },

    createBlankRows(count) {
      const rows = [];
      for (let i = 0; i < count; i += 1) {
        rows.push({
          row_id: null,
          imdb_id: null,
          mode: "create",
          existing_title_id: null,
          fetched: null,
          existing: null,
          fields: this.createBlankFieldSet(),
          warnings: [],
          errors: [],
        });
      }
      return rows;
    },

    createDefaultRowMeta() {
      return {
        row_id: null,
        imdb_id: null,
        input_identifier: null,
        identifier_type: null,
        status_text: "",
        mode: "create",
        existing_title_id: null,
        if_unmodified_since: null,
        warnings: [],
        errors: [],
        poster_url: null,
        existing_assets: {},
      };
    },

    resetRowToBlank(rowIndex, statusText = "") {
      if (!this.hot || rowIndex < 0 || rowIndex >= this.hot.countRows()) {
        return;
      }

      const fields = window.BulkTitleHotConfig.createDataFields();
      fields.forEach((field) => {
        if (field === "__row_status") {
          this.hot.setDataAtRowProp(
            rowIndex,
            field,
            statusText,
            "auto_row_fetch"
          );
          return;
        }

        this.hot.setDataAtRowProp(rowIndex, field, null, "auto_row_fetch");
      });

      const rowMeta = this.rowMeta[rowIndex] || this.createDefaultRowMeta();
      rowMeta.imdb_id = null;
      rowMeta.input_identifier = null;
      rowMeta.identifier_type = null;
      rowMeta.status_text = statusText;
      rowMeta.mode = "create";
      rowMeta.existing_title_id = null;
      rowMeta.if_unmodified_since = null;
      rowMeta.warnings = [];
      rowMeta.errors = [];
      this.rowMeta[rowIndex] = rowMeta;
    },

    ensureRowMetaLength(targetLength) {
      while (this.rowMeta.length < targetLength) {
        this.rowMeta.push(this.createDefaultRowMeta());
      }
      if (this.rowMeta.length > targetLength) {
        this.rowMeta = this.rowMeta.slice(0, targetLength);
      }
    },

    ensureRowCapacity(requiredRows) {
      if (!this.hot || requiredRows <= 0) {
        return;
      }

      const currentRows = this.hot.countRows();
      if (currentRows >= requiredRows) {
        return;
      }

      const addCount = requiredRows - currentRows;
      this.hot.alter(
        "insert_row_below",
        Math.max(currentRows - 1, 0),
        addCount
      );
    },

    setImdbIdsIntoGridFromLines(lines, triggerFetch) {
      if (!this.hot || !Array.isArray(lines) || lines.length === 0) {
        return;
      }

      this.ensureRowCapacity(lines.length);

      lines.forEach((line, index) => {
        this.hot.setDataAtRowProp(index, "t_imdb_id", line, "url_prefill");
      });

      if (!triggerFetch || this.autoFetchTriggered) {
        return;
      }

      this.autoFetchTriggered = true;
      lines.forEach((line, index) => {
        this.fetchAndPopulateRowFromImdb(index, line);
      });
    },

    parseIdentifierInput(value) {
      if (!value && value !== 0) {
        return null;
      }

      const raw = String(value).trim();
      if (!raw) {
        return null;
      }

      const exactMatch = raw.match(/^(tt\d+)$/i);
      if (exactMatch) {
        return {
          type: "imdb",
          value: exactMatch[1].toLowerCase(),
        };
      }

      const urlMatch = raw.match(/\/title\/(tt\d+)/i);
      if (urlMatch) {
        return {
          type: "imdb",
          value: urlMatch[1].toLowerCase(),
        };
      }

      if (/^\d+$/.test(raw)) {
        return {
          type: "title_id",
          value: raw,
        };
      }

      const studioIdMatch = raw.match(/^es-\d+-\d+$/i);
      if (studioIdMatch) {
        return {
          type: "studio_id",
          value: studioIdMatch[0].toUpperCase(),
        };
      }

      return null;
    },

    parseColumnIdentifier(prop, rawValue) {
      if (!rawValue && rawValue !== 0) return null;
      const raw = String(rawValue).trim();
      if (!raw) return null;

      if (prop === "t_imdb_id") {
        const exactMatch = raw.match(/^(tt\d+)$/i);
        if (exactMatch)
          return { type: "imdb", value: exactMatch[1].toLowerCase() };
        const urlMatch = raw.match(/\/title\/(tt\d+)/i);
        if (urlMatch) return { type: "imdb", value: urlMatch[1].toLowerCase() };
        return null;
      }

      if (prop === "__studio_id") {
        if (/^[a-z][a-z0-9_]*$/i.test(raw))
          return { type: "studio_id", value: raw.toUpperCase() };
        return null;
      }

      if (prop === "__title_id") {
        if (/^\d+$/.test(raw)) return { type: "title_id", value: raw };
        return null;
      }

      return null;
    },

    parseStoredIdentifierKey(identifierKey) {
      if (!identifierKey || typeof identifierKey !== "string") {
        return null;
      }

      const parts = identifierKey.split(":");
      if (parts.length < 2) {
        return null;
      }

      const type = parts[0];
      const value = parts.slice(1).join(":");
      if (!type || !value) {
        return null;
      }

      return { type, value };
    },

    findDuplicateRow(currentRowIndex, identifier) {
      if (!this.hot || !identifier) return -1;
      const rows = this.hot.countRows();
      const ID_PROPS = ["t_imdb_id", "__studio_id", "__title_id"];
      for (let i = 0; i < rows; i++) {
        if (i === currentRowIndex) continue;
        for (let p = 0; p < ID_PROPS.length; p++) {
          const val = this.hot.getDataAtRowProp(i, ID_PROPS[p]);
          const other = this.parseColumnIdentifier(ID_PROPS[p], val);
          if (
            other &&
            other.type === identifier.type &&
            other.value === identifier.value
          ) {
            return i;
          }
        }
      }
      return -1;
    },

    updateRowStatus(
      rowIndex,
      statusText,
      source = "auto_row_fetch",
      statusDetail = ""
    ) {
      if (!this.hot || rowIndex < 0 || rowIndex >= this.hot.countRows()) {
        return;
      }

      this.ensureRowMetaLength(this.hot.countRows());
      if (!this.rowMeta[rowIndex]) {
        this.rowMeta[rowIndex] = this.createDefaultRowMeta();
      }

      this.rowMeta[rowIndex].status_text = statusText;
      this.hot.setDataAtRowProp(
        rowIndex,
        "__row_status",
        {
          text: statusText,
          detail: statusDetail || "",
        },
        source
      );
    },

    async fetchAndPopulateRowFromImdb(
      rowIndex,
      rawImdbInput,
      activeProp = "t_imdb_id"
    ) {
      if (!this.hot || rowIndex < 0 || rowIndex >= this.hot.countRows()) {
        return;
      }

      const identifier = this.parseColumnIdentifier(activeProp, rawImdbInput);
      if (!identifier) {
        delete this.pendingRowFetchTokens[rowIndex];

        const rawValue = rawImdbInput ? String(rawImdbInput).trim() : "";
        if (rawValue !== "") {
          let formatHint;
          if (activeProp === "__studio_id") {
            formatHint = "Use studio code format (e.g. BAY_ANOTU).";
          } else if (activeProp === "__title_id") {
            formatHint = "Enter a numeric title ID.";
          } else {
            formatHint = "Use IMDB ID (tt...) or IMDB URL.";
          }
          this.resetRowToBlank(rowIndex, "Error");
          this.updateRowStatus(
            rowIndex,
            "Error",
            "auto_row_fetch",
            `Invalid identifier. ${formatHint}`
          );
          return;
        }

        this.resetRowToBlank(rowIndex, "");
        return;
      }

      // Dedup: check if this identifier already exists in another row
      const dupRow = this.findDuplicateRow(rowIndex, identifier);
      if (dupRow !== -1) {
        this.resetRowToBlank(rowIndex, "Error");
        this.updateRowStatus(
          rowIndex,
          "Error",
          "auto_row_fetch",
          `Duplicate: same identifier already in row ${dupRow + 1}.`
        );
        return;
      }

      const token = Date.now() + Math.random();
      this.pendingRowFetchTokens[rowIndex] = { token, prop: activeProp };
      this.setLoading(true, `Fetching ${identifier.value}...`);
      this.updateRowStatus(rowIndex, "Loading...", "auto_row_fetch");

      try {
        const response = await fetch("/api/admin/bulk-titles/preview", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            identifiers: [identifier.value],
            destination:
              this.hot.getDataAtRowProp(rowIndex, "__import_destination") ||
              "SD",
          }),
        });
        const payload = await response.json();

        if (
          !this.pendingRowFetchTokens[rowIndex] ||
          this.pendingRowFetchTokens[rowIndex].token !== token
        ) {
          return;
        }

        if (!response.ok || !payload.success) {
          this.updateRowStatus(
            rowIndex,
            "Error",
            "auto_row_fetch",
            (payload && payload.message) ||
              `Failed to fetch ${identifier.value}.`
          );
          return;
        }

        const data = payload.data || {};
        if (data.lookups && Object.keys(data.lookups).length > 0) {
          this.setLookups(data.lookups);
        }

        const rows = Array.isArray(data.rows) ? data.rows : [];
        const row = rows.length > 0 ? rows[0] : null;
        if (!row || !row.fields) {
          this.updateRowStatus(
            rowIndex,
            "Not found",
            "auto_row_fetch",
            `No preview data returned for ${identifier.value}.`
          );
          return;
        }

        const currentIdentifierInRow = this.parseColumnIdentifier(
          activeProp,
          this.hot.getDataAtRowProp(rowIndex, activeProp)
        );
        if (
          !currentIdentifierInRow ||
          currentIdentifierInRow.type !== identifier.type ||
          currentIdentifierInRow.value !== identifier.value
        ) {
          return;
        }

        this.applyFetchedRowToGrid(rowIndex, row, identifier, activeProp);

        // Async synopsis rewrite kicked off server-side in buildPreview().
        // Until it finishes, blank the three synopsis cells and show a
        // placeholder so the user knows we're not importing the raw IMDb
        // description. The poll will replace them with the rewritten text.
        // Skip for update-mode rows that already have synopsis data in the
        // DB — the backend won't rewrite those either.
        const isUpdate = row.mode === "update";
        const hasExistingSynopsis =
          isUpdate &&
          row.fields &&
          (row.fields.t_short_synopsis ||
            row.fields.t_medium_synopsis ||
            row.fields.t_long_synopsis);

        if (
          data.synopses_job &&
          data.synopses_job.status === "dispatched" &&
          data.session_id &&
          !hasExistingSynopsis
        ) {
          this.setSynopsisPlaceholders(rowIndex);
          this.pollSynopsisRewriteForRow(
            rowIndex,
            String(data.session_id),
            row.imdb_id || identifier.value
          );
        }
      } catch (error) {
        if (
          !this.pendingRowFetchTokens[rowIndex] ||
          this.pendingRowFetchTokens[rowIndex].token !== token
        ) {
          return;
        }
        this.updateRowStatus(
          rowIndex,
          "Error",
          "auto_row_fetch",
          `Failed fetching ${identifier.value}: ${error.message}`
        );
      } finally {
        if (
          this.pendingRowFetchTokens[rowIndex] &&
          this.pendingRowFetchTokens[rowIndex].token === token
        ) {
          delete this.pendingRowFetchTokens[rowIndex];
        }
        this.setLoading(false, "");
      }
    },

    applyFetchedRowToGrid(
      rowIndex,
      previewRow,
      identifier,
      activeProp = "t_imdb_id"
    ) {
      if (!this.hot) {
        return;
      }

      const displayRow = window.BulkTitleHotConfig.toDisplayRow
        ? window.BulkTitleHotConfig.toDisplayRow(
            previewRow.fields || {},
            this.lookups
          )
        : previewRow.fields || {};

      const fields = window.BulkTitleHotConfig.createDataFields();
      fields.forEach((field) => {
        if (field === "__title_id") {
          if (previewRow.existing_title_id) {
            this.hot.setDataAtRowProp(
              rowIndex,
              field,
              previewRow.existing_title_id,
              "auto_row_fetch"
            );
          }
          return;
        }

        if (field === "__import_destination") {
          return;
        }

        if (field === "__studio_id") {
          if (activeProp !== "__studio_id" && previewRow.studio_id) {
            this.hot.setDataAtRowProp(
              rowIndex,
              field,
              previewRow.studio_id,
              "auto_row_fetch"
            );
          }
          return;
        }

        if (field === "t_imdb_id") {
          if (activeProp === "t_imdb_id") {
            this.hot.setDataAtRowProp(
              rowIndex,
              field,
              previewRow.imdb_id || identifier.value,
              "auto_row_fetch"
            );
          } else if (previewRow.imdb_id) {
            this.hot.setDataAtRowProp(
              rowIndex,
              field,
              previewRow.imdb_id,
              "auto_row_fetch"
            );
          }
          return;
        }

        if (field === "__row_status") {
          return;
        }

        if (Object.prototype.hasOwnProperty.call(displayRow, field)) {
          this.hot.setDataAtRowProp(
            rowIndex,
            field,
            displayRow[field],
            "auto_row_fetch"
          );
        }
      });

      this.ensureRowMetaLength(this.hot.countRows());
      this.rowMeta[rowIndex] = {
        row_id: null,
        imdb_id: previewRow.imdb_id || null,
        input_identifier:
          previewRow.input_identifier ||
          `${identifier.type}:${identifier.value}`,
        identifier_type: previewRow.identifier_type || identifier.type,
        status_text:
          previewRow.errors && previewRow.errors.length > 0
            ? "Error"
            : previewRow.mode === "update"
            ? "Loaded (update)"
            : "Loaded (new)",
        mode: previewRow.mode === "update" ? "update" : "create",
        existing_title_id: previewRow.existing_title_id || null,
        if_unmodified_since:
          previewRow.existing && previewRow.existing.updated_at
            ? previewRow.existing.updated_at
            : null,
        warnings: Array.isArray(previewRow.warnings) ? previewRow.warnings : [],
        errors: Array.isArray(previewRow.errors) ? previewRow.errors : [],
        poster_url:
          (previewRow.fields && previewRow.fields.__poster_url) ||
          (previewRow.fetched && previewRow.fetched.__poster_url) ||
          null,
        existing_assets:
          (previewRow.fields && previewRow.fields.__existing_assets) ||
          (previewRow.fetched && previewRow.fetched.__existing_assets) ||
          {},
      };

      const previewErrors =
        previewRow.errors && previewRow.errors.length > 0
          ? previewRow.errors.join("\n")
          : "";
      const nextStatus = previewErrors
        ? "Error"
        : previewRow.mode === "update"
        ? "Loaded (update)"
        : "Loaded (new)";

      this.updateRowStatus(
        rowIndex,
        nextStatus,
        "auto_row_fetch",
        previewErrors
      );

      this.hot.render();

      // Trigger TMDB image fetch immediately (debounced to batch multiple rows)
      this.queueTmdbFetchForRow(rowIndex);
    },

    /**
     * Replace the three synopsis cells with a loading placeholder. Called
     * right after applyFetchedRowToGrid whenever the backend reports that
     * an async rewrite job has been dispatched for this row, so the grid
     * never shows the raw IMDb description as if it were the final text.
     */
    setSynopsisPlaceholders(rowIndex) {
      if (!this.hot) {
        return;
      }
      const placeholder = "…";
      ["t_short_synopsis", "t_medium_synopsis", "t_long_synopsis"].forEach(
        (field) => {
          this.hot.setDataAtRowProp(
            rowIndex,
            field,
            placeholder,
            "auto_row_fetch"
          );
        }
      );
    },

    _synopsisPollTokens: {},

    /**
     * Poll /api/admin/bulk-titles/synopses-status until the async rewrite
     * job for `sessionId` reports `completed` (or we time out), then fill
     * the row's three synopsis cells with the rewritten text.
     *
     * Per-row token guard: if the user re-fetches the same row before the
     * previous poll finishes, the stale poll is abandoned.
     */
    async pollSynopsisRewriteForRow(rowIndex, sessionId, imdbId) {
      if (!this.hot || !sessionId || !imdbId) {
        return;
      }

      const token = Date.now() + Math.random();
      this._synopsisPollTokens[rowIndex] = token;

      const url = `/api/admin/bulk-titles/synopses-status?session_id=${encodeURIComponent(
        sessionId
      )}`;
      const deadline = Date.now() + 90_000; // 90s ceiling
      const interval = 1500;

      while (Date.now() < deadline) {
        if (this._synopsisPollTokens[rowIndex] !== token) {
          return; // superseded by a newer fetch for the same row
        }

        await new Promise((r) => setTimeout(r, interval));

        if (this._synopsisPollTokens[rowIndex] !== token) {
          return;
        }

        let payload;
        try {
          const resp = await fetch(url, { credentials: "same-origin" });
          payload = await resp.json();
        } catch (err) {
          continue;
        }

        if (!payload || !payload.success || !payload.data) {
          continue;
        }

        const status = payload.data;
        const entry = status.results && status.results[imdbId];

        if (entry && (entry.short || entry.medium || entry.long)) {
          // Partial or full result available — apply what we have.
          if (this._synopsisPollTokens[rowIndex] !== token) {
            return;
          }
          this.applySynopsisResultToRow(rowIndex, entry);

          if (status.status === "completed") {
            delete this._synopsisPollTokens[rowIndex];
            return;
          }
        }

        if (status.status === "completed") {
          // No result for this imdb_id even though the job completed —
          // the rewrite silently failed. Leave placeholders so the user
          // knows, and clean up.
          this.applySynopsisResultToRow(rowIndex, {
            short: "",
            medium: "",
            long: "",
          });
          delete this._synopsisPollTokens[rowIndex];
          return;
        }
      }

      // Timed out. Leave placeholders so user sees something went wrong.
      if (this._synopsisPollTokens[rowIndex] === token) {
        delete this._synopsisPollTokens[rowIndex];
      }
    },

    applySynopsisResultToRow(rowIndex, entry) {
      if (!this.hot || !entry) {
        return;
      }
      const updates = [
        ["t_short_synopsis", entry.short],
        ["t_medium_synopsis", entry.medium],
        ["t_long_synopsis", entry.long],
      ];
      updates.forEach(([field, value]) => {
        this.hot.setDataAtRowProp(
          rowIndex,
          field,
          value && String(value).length > 0 ? value : "",
          "auto_row_fetch"
        );
      });
    },

    _tmdbFetchQueue: [],
    _tmdbFetchDebounce: null,

    queueTmdbFetchForRow(rowIndex) {
      if (!window.BulkTitleVerifyPanel) return;
      const meta = this.rowMeta[rowIndex];
      if (!meta || !meta.imdb_id) return;

      // Don't duplicate
      if (this._tmdbFetchQueue.indexOf(rowIndex) === -1) {
        this._tmdbFetchQueue.push(rowIndex);
      }

      // Debounce: wait 1s after last row arrives, then dispatch batch
      if (this._tmdbFetchDebounce) clearTimeout(this._tmdbFetchDebounce);
      this._tmdbFetchDebounce = setTimeout(() => {
        this.dispatchQueuedTmdbFetch();
      }, 1000);
    },

    dispatchQueuedTmdbFetch() {
      const panel = window.BulkTitleVerifyPanel;
      if (!panel || !panel.assetSpecs || this._tmdbFetchQueue.length === 0) return;

      const sourceData = this.hot ? this.hot.getSourceData() : [];
      const itemMap = {};
      const rowTypeMap = {};

      for (let i = 0; i < this._tmdbFetchQueue.length; i++) {
        const ri = this._tmdbFetchQueue[i];
        const meta = this.rowMeta[ri];
        if (!meta || !meta.imdb_id) continue;

        const destination = sourceData[ri] ? (sourceData[ri].__import_destination || 'SD') : 'SD';
        const platform = panel.getPlatformForDestination(destination);
        const specs = panel.assetSpecs[platform];
        if (!specs) continue;

        const neededTypes = [];
        for (let s = 0; s < specs.length; s++) {
          const cacheKey = meta.imdb_id + ':' + specs[s].type;
          if (panel.tmdbCache[cacheKey] !== undefined) continue;
          neededTypes.push(specs[s].type);
        }
        if (neededTypes.length === 0) continue;

        if (!itemMap[meta.imdb_id]) {
          itemMap[meta.imdb_id] = { types: {} };
          rowTypeMap[meta.imdb_id] = [];
        }
        for (let t = 0; t < neededTypes.length; t++) {
          itemMap[meta.imdb_id].types[neededTypes[t]] = true;
        }
        rowTypeMap[meta.imdb_id].push({ rowIndex: ri, types: neededTypes });
      }

      this._tmdbFetchQueue = [];

      const items = [];
      const imdbIds = Object.keys(itemMap);
      for (let k = 0; k < imdbIds.length; k++) {
        items.push({
          imdb_id: imdbIds[k],
          types: Object.keys(itemMap[imdbIds[k]].types),
        });
      }

      if (items.length === 0) return;

      panel._batchRowMap = rowTypeMap;
      panel._lastAppliedCount = 0;
      panel.dispatchBatchFetch(items);
    },

    handleImdbCellChanges(changes, source) {
      if (!changes || !Array.isArray(changes)) {
        return;
      }

      if (
        source === "loadData" ||
        source === "auto_row_fetch" ||
        source === "session_refresh" ||
        source === "url_prefill" ||
        source === "verify_edit"
      ) {
        return;
      }

      const ID_PROPS = ["t_imdb_id", "__studio_id", "__title_id"];
      changes.forEach((change) => {
        const rowIndex = Number(change[0]);
        const prop = change[1];
        const oldValue = change[2];
        const newValue = change[3];

        if (prop === "__import_destination") {
          if (oldValue === newValue) {
            return;
          }
          const meta = this.rowMeta[rowIndex];
          if (meta && meta.mode === "update") {
            return;
          }
          this.updateStudioIdForDestination(rowIndex, newValue);
          return;
        }

        if (prop === "t_labels") {
          this.handleLabelChangeForStudioId(rowIndex, oldValue, newValue);
          return;
        }

        if (!ID_PROPS.includes(prop)) {
          return;
        }

        const oldIdentifier = this.parseColumnIdentifier(prop, oldValue);
        const newIdentifier = this.parseColumnIdentifier(prop, newValue);
        if (
          oldIdentifier &&
          newIdentifier &&
          oldIdentifier.type === newIdentifier.type &&
          oldIdentifier.value === newIdentifier.value
        ) {
          return;
        }

        if (newValue !== null && newValue !== "") {
          ID_PROPS.forEach((idProp) => {
            if (idProp !== prop) {
              this.hot.setDataAtRowProp(
                rowIndex,
                idProp,
                null,
                "auto_row_fetch"
              );
            }
          });
        }

        this.fetchAndPopulateRowFromImdb(rowIndex, newValue, prop);
      });
    },

    async refreshSessionForSave() {
      if (!this.hot) {
        return false;
      }

      const sourceRows = this.hot.getSourceData();
      const identifiers = [];
      const identifierPerRow = [];
      const identifierCounts = {};

      sourceRows.forEach((row, rowIndex) => {
        let identifier =
          this.parseColumnIdentifier("t_imdb_id", row.t_imdb_id) ||
          this.parseColumnIdentifier("__studio_id", row.__studio_id) ||
          this.parseColumnIdentifier("__title_id", row.__title_id);
        if (!identifier) {
          identifier = this.parseStoredIdentifierKey(
            this.rowMeta[rowIndex] && this.rowMeta[rowIndex].input_identifier
              ? this.rowMeta[rowIndex].input_identifier
              : null
          );
        }

        identifierPerRow.push(identifier);

        if (!identifier) {
          return;
        }

        const key = `${identifier.type}:${identifier.value}`;
        identifiers.push(identifier.value);
        identifierCounts[key] = (identifierCounts[key] || 0) + 1;
      });

      const duplicates = Object.keys(identifierCounts)
        .filter((key) => identifierCounts[key] > 1)
        .map((key) => key.split(":").slice(1).join(":"));

      if (duplicates.length > 0) {
        this.showAlert(
          `Duplicate identifiers found: ${duplicates.join(
            ", "
          )}. Keep one row per identifier before saving.`,
          "warning"
        );
        return false;
      }

      const uniqueIdentifiers = Array.from(new Set(identifiers));
      if (uniqueIdentifiers.length === 0) {
        this.showAlert(
          "Add at least one valid identifier before saving.",
          "warning"
        );
        return false;
      }

      const response = await fetch("/api/admin/bulk-titles/preview", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ identifiers: uniqueIdentifiers }),
      });
      const payload = await response.json();

      if (!response.ok || !payload.success) {
        this.showAlert(
          (payload && payload.message) || "Failed preparing save session.",
          "alert"
        );
        return false;
      }

      const data = payload.data || {};
      if (this.elements.sessionId) {
        this.elements.sessionId.value = data.session_id || "";
      }
      if (data.lookups && Object.keys(data.lookups).length > 0) {
        this.setLookups(data.lookups);
      }

      const sessionRows = Array.isArray(data.rows) ? data.rows : [];
      const sessionByIdentifier = {};
      sessionRows.forEach((row) => {
        if (row && row.input_identifier) {
          sessionByIdentifier[String(row.input_identifier).toLowerCase()] = row;
        }
      });

      this.ensureRowMetaLength(sourceRows.length);
      sourceRows.forEach((_, rowIndex) => {
        const identifier = identifierPerRow[rowIndex];
        if (!identifier) {
          this.rowMeta[rowIndex] = this.createDefaultRowMeta();
          return;
        }

        const sessionKey = `${identifier.type}:${identifier.value}`.toLowerCase();
        const sessionRow = sessionByIdentifier[sessionKey] || null;
        this.rowMeta[rowIndex] = {
          row_id: sessionRow ? sessionRow.row_id : null,
          imdb_id: sessionRow ? sessionRow.imdb_id || null : null,
          input_identifier: sessionKey,
          identifier_type: sessionRow
            ? sessionRow.identifier_type
            : identifier.type,
          mode:
            sessionRow && sessionRow.mode === "update" ? "update" : "create",
          existing_title_id: sessionRow
            ? sessionRow.existing_title_id || null
            : null,
          if_unmodified_since:
            sessionRow && sessionRow.existing && sessionRow.existing.updated_at
              ? sessionRow.existing.updated_at
              : null,
          warnings:
            sessionRow && Array.isArray(sessionRow.warnings)
              ? sessionRow.warnings
              : [],
          errors:
            sessionRow && Array.isArray(sessionRow.errors)
              ? sessionRow.errors
              : [],
        };

        this.hot.setDataAtRowProp(
          rowIndex,
          "t_imdb_id",
          sessionRow
            ? sessionRow.imdb_id || identifier.value
            : identifier.value,
          "session_refresh"
        );
      });

      return true;
    },

    computeGridHeight() {
      if (!this.elements.hotContainer) {
        return 520;
      }

      const containerTop = this.elements.hotContainer.getBoundingClientRect()
        .top;
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const viewportFillHeight = Math.max(
        viewportHeight - containerTop - 24,
        360
      );

      return viewportFillHeight;
    },

    syncGridHeight() {
      if (!this.hot) {
        return;
      }

      const gridHeight = this.computeGridHeight();
      this.hot.updateSettings({
        height: gridHeight,
      });

      if (this.hotIframe) {
        this.hotIframe.style.height = `${gridHeight}px`;
      }

      if (this.elements.hotContainer) {
        this.elements.hotContainer.style.minHeight = `${gridHeight}px`;
      }
    },

    prepareHotHost() {
      this.hotIframe = null;
      this.hotMountElement = this.elements.hotContainer;

      if (!this.urlOptions.iframeGrid || !this.elements.hotContainer) {
        return;
      }

      this.elements.hotContainer.innerHTML = "";

      const iframe = document.createElement("iframe");
      iframe.id = "bulk-title-hot-iframe";
      iframe.className = "bulk-import-hot-iframe";
      iframe.title = "Bulk title import grid";
      iframe.setAttribute("scrolling", "no");

      this.elements.hotContainer.appendChild(iframe);

      const iframeDocument = iframe.contentDocument;
      if (!iframeDocument) {
        return;
      }

      iframeDocument.open();
      iframeDocument.write(`<!doctype html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<link rel="stylesheet" href="/css/handsontable/styles/handsontable.min.css">
<link rel="stylesheet" href="/css/handsontable/styles/ht-theme-classic.min.css">
<style>
  html, body { margin: 0; padding: 0; background: #ffffff; color: #111111; overflow: hidden; }
  #bulk-title-hot-iframe-root { width: 100%; height: 100%; }
  .ht-status-loading { color: #888; }
  .ht-status-new { color: #2a8a4e; font-weight: 700; }
  .ht-status-update { color: #1a6ebd; font-weight: 700; }
  .ht-status-error { color: #c42222; font-weight: 700; }
  .ht-status-notfound { color: #b06800; font-weight: 700; }
  .ht-status-saved { color: #2a8a4e; font-weight: 700; }
  .ht-status-unknown { color: #555; }
</style>
</head>
<body class="bulk-title-import-page">
  <div id="bulk-title-hot-iframe-root"></div>
</body>
</html>`);
      iframeDocument.close();

      const iframeWindow = iframe.contentWindow;
      if (iframeWindow && window.Handsontable) {
        iframeWindow.Handsontable = window.Handsontable;
      }

      this.hotIframe = iframe;
      this.hotMountElement = iframeDocument.getElementById(
        "bulk-title-hot-iframe-root"
      );
    },

    renderHandsontable(rows, lookups) {
      if (!this.elements.hotContainer || !window.BulkTitleHotConfig) {
        this.showAlert("Handsontable failed to load in this page.", "alert");
        return;
      }

      if (!this.hotMountElement) {
        this.prepareHotHost();
      }

      const mountElement = this.hotMountElement || this.elements.hotContainer;
      const handsontableCtor =
        this.hotIframe &&
        this.hotIframe.contentWindow &&
        this.hotIframe.contentWindow.Handsontable
          ? this.hotIframe.contentWindow.Handsontable
          : window.Handsontable;

      if (!mountElement || !handsontableCtor) {
        this.showAlert("Handsontable failed to load in this page.", "alert");
        return;
      }

      this.destroyHot();

      const fields = window.BulkTitleHotConfig.createDataFields();
      const colHeaders = window.BulkTitleHotConfig.createHeaders();
      const columns = window.BulkTitleHotConfig.createColumns(lookups);

      this.rowMeta = rows.map((row) => ({
        row_id: row.row_id,
        imdb_id: row.imdb_id,
        input_identifier: row.input_identifier || null,
        identifier_type: row.identifier_type || null,
        status_text:
          Array.isArray(row.errors) && row.errors.length > 0
            ? "Error"
            : !row.imdb_id && !row.input_identifier
            ? ""
            : row.mode === "update"
            ? "Loaded (update)"
            : "Loaded (new)",
        mode: row.mode || "create",
        existing_title_id: row.existing_title_id || null,
        if_unmodified_since:
          row.existing && row.existing.updated_at
            ? row.existing.updated_at
            : null,
        warnings: Array.isArray(row.warnings) ? row.warnings : [],
        errors: Array.isArray(row.errors) ? row.errors : [],
      }));

      const dataRows = rows.map((row) => {
        const payload = row.fields || row.fetched || {};
        const result = {};

        fields.forEach((field) => {
          if (field === "__row_status") {
            result[field] =
              Array.isArray(row.errors) && row.errors.length > 0
                ? "Error"
                : !row.imdb_id && !row.input_identifier
                ? ""
                : row.mode === "update"
                ? "Loaded (update)"
                : "Loaded (new)";
            return;
          }

          if (typeof payload[field] === "undefined") {
            result[field] = null;
          } else {
            result[field] = payload[field];
          }
        });

        if (window.BulkTitleHotConfig.toDisplayRow) {
          return window.BulkTitleHotConfig.toDisplayRow(result, lookups);
        }

        return result;
      });

      this.hot = new handsontableCtor(mountElement, {
        data: dataRows,
        rowHeaders: true,
        colHeaders,
        columns,
        colWidths: window.BulkTitleHotConfig.createColumnWidths(),
        licenseKey: "non-commercial-and-evaluation",
        theme: "ht-theme-classic",
        stretchH: "all",
        width: "100%",
        height: this.computeGridHeight(),
        rowHeights: 30,
        columnHeaderHeight: 30,
        autoWrapRow: false,
        autoWrapCol: false,
        fillHandle: {
          autoInsertRow: true,
        },
        minSpareRows: 10,
        copyPaste: true,
        undo: true,
        manualColumnResize: true,
        manualColumnMove: true,
        manualRowResize: true,
        contextMenu: true,
        filters: true,
        dropdownMenu: true,
        columnSorting: true,
        hiddenColumns: {
          columns: [],
        },
        cells: (row, col) => {
          const cellProperties = {};
          const classNames = [];
          const meta = this.rowMeta[row];
          /* Fields locked for existing titles to prevent data corruption */
          const LOCKED_FIELDS_FOR_EXISTING = [
            "t_director",
            "t_writer",
            "t_producer",
            "t_cast",
            "t_exec_producers",
            "__import_destination",
          ];

          if (meta) {
            if (meta.errors && meta.errors.length > 0) {
              classNames.push("bulk-import-row-failed");
            } else if (meta.mode === "update") {
              classNames.push("bulk-import-row-update");
            } else {
              classNames.push("bulk-import-row-create");
            }

            /* Lock certain cells for existing titles to prevent data corruption */
            const hotCols = this.hot ? this.hot.getSettings().columns : columns;
            if (
              meta.mode === "update" &&
              Number.isInteger(col) &&
              col >= 0 &&
              hotCols[col] &&
              LOCKED_FIELDS_FOR_EXISTING.indexOf(hotCols[col].data) !== -1
            ) {
              cellProperties.readOnly = true;
              classNames.push("bulk-import-cell-locked");
            }
          }

          if (Number.isInteger(col) && col >= 0) {
            classNames.push("bulk-import-cell-truncate");
            cellProperties.wordWrap = false;
          }

          if (classNames.length > 0) {
            cellProperties.className = classNames.join(" ");
          }

          return cellProperties;
        },
        afterChange: (changes, source) => {
          this.handleImdbCellChanges(changes, source);
        },
        afterCreateRow: (index, amount) => {
          const insertAt = Number.isInteger(index)
            ? index
            : this.rowMeta.length;
          const newMeta = [];
          for (let i = 0; i < amount; i += 1) {
            newMeta.push(this.createDefaultRowMeta());
          }
          this.rowMeta.splice(insertAt, 0, ...newMeta);
          if (this.hot) {
            for (let i = 0; i < amount; i += 1) {
              const rowIndex = insertAt + i;
              this.hot.setDataAtRowProp(
                rowIndex,
                "__row_status",
                "",
                "session_refresh"
              );
            }
          }
          this.pendingRowFetchTokens = {};
          this.syncGridHeight();
        },
        afterRemoveRow: (index, amount) => {
          const removeAt = Number.isInteger(index) ? index : 0;
          this.rowMeta.splice(removeAt, amount);
          this.ensureRowMetaLength(this.hot ? this.hot.countRows() : 0);
          this.pendingRowFetchTokens = {};
          this.syncGridHeight();
        },
        afterRender: () => {
          this.applyNativeHotReset();
        },
      });

      if (this.hotIframe && this.hotIframe.contentWindow) {
        this.hotIframe.contentWindow.__bulkTitleHotInstance = this.hot;
      }

      this.ensureRowMetaLength(this.hot.countRows());
      this.syncGridHeight();
      this.applyNativeHotReset();
    },

    async saveRows(onlyFailed) {
      if (!this.hot) {
        this.showAlert("Grid is not ready yet.", "warning");
        return;
      }

      this.setSavingState(true, "Preparing rows...");
      try {
        const prepared = await this.refreshSessionForSave();
        if (
          !prepared ||
          !this.elements.sessionId ||
          !this.elements.sessionId.value
        ) {
          this.setSavingState(false, "");
          return;
        }
      } catch (error) {
        this.setSavingState(false, "");
        this.showAlert(
          `Failed preparing save session: ${error.message}`,
          "alert"
        );
        return;
      }

      const rows = this.buildSaveRows(onlyFailed);
      if (rows.length === 0) {
        this.setSavingState(false, "");
        this.showAlert("No rows selected to save.", "warning");
        return;
      }

      // Validate all rows first (dry run)
      this.setSavingState(true, "Validating rows...");
      this.clearAlert();

      try {
        const dryRunPayload = await this.submitSaveRequest(rows, true);
        if (!dryRunPayload.success) {
          this.showAlert(
            (dryRunPayload && dryRunPayload.message) || "Validation failed.",
            "alert"
          );
          this.setSavingState(false, "");
          return;
        }
      } catch (error) {
        this.showAlert(`Validation failed: ${error.message}`, "alert");
        this.setSavingState(false, "");
        return;
      }

      // Import one by one with progress
      const resultsContainer = document.getElementById("bulk-import-results");
      if (resultsContainer) {
        resultsContainer.style.display = "";
        resultsContainer.textContent = "";
      }

      const allResults = [];
      const summary = { created: 0, updated: 0, failed: 0, skipped: 0 };
      this.failedRowIds = [];

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const titleName = row.fields.t_title || row.fields.title || `Row ${row.row_id}`;
        this.setSavingState(true, `Importing ${i + 1}/${rows.length}: ${titleName}...`);
        this.updateImportProgress(i, rows.length, allResults, resultsContainer);

        try {
          const payload = await this.submitSaveRequest([row], false);
          const resultRows = payload.data && Array.isArray(payload.data.results)
            ? payload.data.results : [];
          const result = resultRows.length > 0 ? resultRows[0] : null;

          if (result) {
            allResults.push(result);
            if (result.status === "created") summary.created++;
            else if (result.status === "updated") summary.updated++;
            else if (result.status === "failed") {
              summary.failed++;
              this.failedRowIds.push(result.row_id);
            }
          } else {
            allResults.push({
              row_id: row.row_id, status: "failed",
              errors: [(payload && payload.message) || "Unknown error"],
            });
            summary.failed++;
            this.failedRowIds.push(row.row_id);
          }
        } catch (error) {
          allResults.push({
            row_id: row.row_id, status: "failed",
            errors: [error.message],
          });
          summary.failed++;
          this.failedRowIds.push(row.row_id);
        }

        this.updateImportProgress(i + 1, rows.length, allResults, resultsContainer);
      }

      // Final state
      if (this.elements.retryButton) {
        this.elements.retryButton.style.display =
          this.failedRowIds.length > 0 ? "inline-block" : "none";
      }

      this.showSummary(summary);
      this.applyResultMeta(allResults);
      this.applyResultStatuses(allResults);
      if (this.hot) this.hot.render();

      this.showAlert(
        `Import complete: created ${summary.created}, updated ${summary.updated}, failed ${summary.failed}.`,
        this.failedRowIds.length > 0 ? "warning" : "success"
      );
      this.setSavingState(false, "");
    },

    updateImportProgress(completed, total, results, container) {
      if (!container) return;
      container.textContent = "";

      // Progress bar
      const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
      const bar = document.createElement("div");
      bar.style.cssText = "margin-bottom:0.75rem;";

      const barLabel = document.createElement("div");
      barLabel.style.cssText = "font-size:13px;color:#ccc;margin-bottom:4px;";
      barLabel.textContent = completed + " / " + total + " titles processed";
      bar.appendChild(barLabel);

      const barTrack = document.createElement("div");
      barTrack.style.cssText = "height:6px;background:#2d2d44;border-radius:3px;overflow:hidden;";
      const barFill = document.createElement("div");
      barFill.style.cssText = "height:100%;background:#6c63ff;border-radius:3px;transition:width 0.3s;width:" + pct + "%;";
      barTrack.appendChild(barFill);
      bar.appendChild(barTrack);
      container.appendChild(bar);

      // Per-row results
      for (let i = 0; i < results.length; i++) {
        const r = results[i];
        const line = document.createElement("div");
        line.style.cssText = "font-size:12px;padding:2px 0;display:flex;gap:0.5rem;align-items:center;";

        const icon = document.createElement("span");
        if (r.status === "created" || r.status === "updated") {
          icon.textContent = "\u2713";
          icon.style.color = "#4caf50";
        } else {
          icon.textContent = "\u2717";
          icon.style.color = "#ef5350";
        }
        line.appendChild(icon);

        const text = document.createElement("span");
        text.style.color = "#ccc";
        text.textContent = "Row " + r.row_id + ": " + r.status;
        if (r.status === "failed" && r.errors && r.errors.length > 0) {
          text.textContent += " - " + r.errors[0];
        }
        if (r.title_id) {
          text.textContent += " (ID: " + r.title_id + ")";
        }
        line.appendChild(text);

        container.appendChild(line);
      }
    },

    buildSaveRows(onlyFailed) {
      if (!this.hot) {
        return [];
      }

      const sourceData = this.hot.getSourceData();
      const rows = [];
      for (let i = 0; i < sourceData.length; i += 1) {
        const meta = this.rowMeta[i];
        if (!meta) {
          continue;
        }

        const identifier = this.parseIdentifierInput(sourceData[i].t_imdb_id);
        if (!identifier && (!meta || !meta.input_identifier)) {
          continue;
        }

        if (meta.row_id === null || meta.row_id === undefined) {
          continue;
        }

        if (onlyFailed && this.failedRowIds.indexOf(meta.row_id) === -1) {
          continue;
        }

        var pendingAssetKeys = window.BulkTitleVerifyPanel
          ? Object.keys(window.BulkTitleVerifyPanel.getPendingAssetsForRow(i))
          : [];

        // Collect suggested assets (TMDB/IMDB picks) for this row
        var suggestedAssetUrls = {};
        if (window.BulkTitleVerifyPanel && window.BulkTitleVerifyPanel.suggestedAssets) {
          var prefix = i + ":";
          var allSuggested = window.BulkTitleVerifyPanel.suggestedAssets;
          for (var key in allSuggested) {
            if (key.indexOf(prefix) === 0 && allSuggested[key]) {
              var assetType = key.substring(prefix.length);
              // Don't include if user already uploaded a file for this slot
              if (pendingAssetKeys.indexOf(assetType) === -1) {
                suggestedAssetUrls[assetType] = allSuggested[key].url;
              }
            }
          }
        }

        rows.push({
          row_id: meta.row_id,
          mode: meta.mode,
          title_id: meta.existing_title_id,
          if_unmodified_since: meta.if_unmodified_since,
          destination: sourceData[i].__import_destination || "SD",
          fields: window.BulkTitleHotConfig.toSaveRow
            ? window.BulkTitleHotConfig.toSaveRow(sourceData[i], this.lookups)
            : sourceData[i],
          pending_assets: pendingAssetKeys,
          suggested_assets: suggestedAssetUrls,
        });
      }

      return rows;
    },

    async submitSaveRequest(rows, dryRun) {
      const response = await fetch("/api/admin/bulk-titles/save", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          session_id: this.elements.sessionId
            ? this.elements.sessionId.value
            : "",
          idempotency_key: this.buildIdempotencyKey(dryRun),
          dry_run: dryRun,
          rows,
        }),
      });

      return response.json();
    },

    applyResultMeta(resultRows) {
      const byRowId = {};
      resultRows.forEach((result) => {
        byRowId[result.row_id] = result;
      });

      this.rowMeta = this.rowMeta.map((meta) => {
        const result = byRowId[meta.row_id];
        if (!result) {
          return meta;
        }

        return {
          row_id: meta.row_id,
          imdb_id: meta.imdb_id,
          input_identifier: meta.input_identifier || null,
          identifier_type: meta.identifier_type || null,
          status_text: result.status === "failed" ? "Save failed" : "Saved",
          mode: result.status === "created" ? "update" : meta.mode,
          existing_title_id: result.title_id || meta.existing_title_id,
          if_unmodified_since: result.updated_at || meta.if_unmodified_since,
          warnings: Array.isArray(result.warnings) ? result.warnings : [],
          errors: Array.isArray(result.errors) ? result.errors : [],
        };
      });
    },

    applyResultStatuses(resultRows) {
      if (!this.hot || !Array.isArray(resultRows)) {
        return;
      }

      const byRowId = {};
      resultRows.forEach((result) => {
        byRowId[result.row_id] = result;
      });

      this.rowMeta.forEach((meta, rowIndex) => {
        if (!meta || meta.row_id === null || meta.row_id === undefined) {
          return;
        }

        const result = byRowId[meta.row_id];
        if (!result) {
          return;
        }

        const nextStatus =
          result.status === "failed"
            ? "Save failed"
            : result.status === "updated"
            ? "Saved (updated)"
            : result.status === "created"
            ? "Saved (created)"
            : "Saved";

        const detail =
          result.status === "failed" && Array.isArray(result.errors)
            ? result.errors.join("\n")
            : "";

        this.updateRowStatus(rowIndex, nextStatus, "session_refresh", detail);
      });
    },

    showSummary(summary) {
      if (!this.elements.summary) {
        return;
      }

      this.elements.summary.style.display = "block";
      this.elements.summary.className = "callout bulk-import-summary info";
      this.elements.summary.textContent = `Created: ${
        summary.created || 0
      }, Updated: ${summary.updated || 0}, Failed: ${
        summary.failed || 0
      }, Skipped: ${summary.skipped || 0}`;
    },

    hideSummary() {
      if (!this.elements.summary) {
        return;
      }

      this.elements.summary.style.display = "none";
      this.elements.summary.textContent = "";
    },

    buildIdempotencyKey(dryRun) {
      const mode = dryRun ? "dry" : "save";
      return `bulk_${mode}_${Date.now()}`;
    },

    applyNativeHotReset() {
      if (this.urlOptions.iframeGrid) {
        return;
      }

      if (!this.hotMountElement) {
        return;
      }

      const scopeRoot = this.hotMountElement;
      const scopeDocument = scopeRoot.ownerDocument || document;

      const hotNodes = scopeRoot.querySelectorAll(".handsontable");

      hotNodes.forEach((node) => {
        node.classList.add("hot-native-reset");
        node.style.setProperty("color-scheme", "light", "important");
        node.style.setProperty("--ht-foreground-color", "#313131", "important");
        node.style.setProperty(
          "--ht-header-foreground-color",
          "#313131",
          "important"
        );
        node.style.setProperty("--ht-background-color", "#ffffff", "important");
        node.style.setProperty(
          "--ht-header-background-color",
          "#f5f5f5",
          "important"
        );
      });

      const headerNodes = scopeRoot.querySelectorAll(
        ".ht_clone_top th, .ht_clone_top_left_corner th, th.htColHeader, .ht_clone_left td, td.htRowHeader, th.htRowHeader"
      );
      headerNodes.forEach((node) => {
        node.style.setProperty("background", "#f5f5f5", "important");
        node.style.setProperty("color", "#222", "important");
        node.style.setProperty("padding", "4px 8px", "important");
        node.style.setProperty("height", "30px", "important");
        node.style.setProperty("line-height", "1.2", "important");
        node.style.setProperty("white-space", "nowrap", "important");
      });

      const headerTextNodes = scopeRoot.querySelectorAll(
        ".ht_clone_top th *, .ht_clone_top_left_corner th *, th.htColHeader *"
      );
      headerTextNodes.forEach((node) => {
        node.style.setProperty("color", "#222", "important");
        node.style.setProperty("white-space", "nowrap", "important");
      });

      const dataNodes = scopeRoot.querySelectorAll(".ht_master tbody td");
      dataNodes.forEach((node) => {
        node.style.setProperty("background", "#fff", "important");
        node.style.setProperty("color", "#111", "important");
        node.style.setProperty("padding", "4px 8px", "important");
        node.style.setProperty("overflow", "hidden", "important");
        node.style.setProperty("text-overflow", "ellipsis", "important");
        node.style.setProperty("white-space", "nowrap", "important");
        node.style.setProperty("line-height", "1.3", "important");
      });

      const dataInnerNodes = scopeRoot.querySelectorAll(
        ".ht_master tbody td *, .ht_master tbody td > div, .ht_master tbody td > span"
      );
      dataInnerNodes.forEach((node) => {
        node.style.setProperty("color", "#111", "important");
        node.style.setProperty("overflow", "hidden", "important");
        node.style.setProperty("text-overflow", "ellipsis", "important");
        node.style.setProperty("white-space", "nowrap", "important");
      });

      const dropdownIconNodes = scopeDocument.querySelectorAll(
        ".changeType, .htAutocompleteArrow"
      );
      dropdownIconNodes.forEach((node) => {
        node.style.setProperty("color", "#4d4d4d", "important");
        node.style.setProperty("opacity", "0.9", "important");
      });
    },

    parseLines(value) {
      return value
        .split(/\r\n|\r|\n/)
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
    },

    setLoading(loading, message) {
      if (this.elements.addRowButton) {
        this.elements.addRowButton.disabled = loading;
      }

      if (this.elements.status) {
        this.elements.status.textContent = message || "";
      }
    },

    setSavingState(saving, message) {
      if (this.elements.saveButton) {
        this.elements.saveButton.disabled = saving;
      }

      if (this.elements.retryButton) {
        this.elements.retryButton.disabled = saving;
      }

      if (this.elements.addRowButton) {
        this.elements.addRowButton.disabled = saving;
      }

      if (this.elements.status) {
        this.elements.status.textContent = message || "";
      }
    },

    setSaveEnabled(enabled) {
      if (this.elements.saveButton) {
        this.elements.saveButton.disabled = !enabled;
      }
    },

    downloadCsv() {
      let hotInstance = this.hot;

      // If HOT is in iframe, get it from there
      if (!hotInstance && this.hotIframe && this.hotIframe.contentWindow) {
        hotInstance = this.hotIframe.contentWindow.__bulkTitleHotInstance;
      }

      if (!hotInstance) {
        this.showAlert("Grid is not ready yet.", "warning");
        return;
      }

      const today = new Date();
      const dateStr = today.toISOString().slice(0, 10);
      const filename = "bulk-title-import-" + dateStr + ".csv";

      // Skip column 0 (__row_status) - it stores objects that export as [object Object]
      const colCount = hotInstance.countCols();
      const headers = [];
      for (let col = 1; col < colCount; col++) {
        const header = hotInstance.getColHeader(col) || "";
        headers.push(this.escapeCsvValue(header));
      }

      const rowCount = hotInstance.countRows();
      const rows = [];
      for (let row = 0; row < rowCount; row++) {
        const rowData = hotInstance.getDataAtRow(row);
        const hasData = rowData
          .slice(1)
          .some((val) => val !== null && val !== undefined && val !== "");
        if (!hasData) continue;

        const rowValues = [];
        for (let col = 1; col < colCount; col++) {
          let value = hotInstance.getDataAtCell(row, col);
          if (value && typeof value === "object") {
            value = value.text || value.toString();
          }
          rowValues.push(this.escapeCsvValue(value));
        }
        rows.push(rowValues.join(","));
      }

      const csvContent = headers.join(",") + "\r\n" + rows.join("\r\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    escapeCsvValue(value) {
      if (value === null || value === undefined) {
        return "";
      }
      const str = String(value);
      const needsQuoting = /[,"\r\n]/.test(str);
      return needsQuoting ? '"' + str.replace(/"/g, '""') + '"' : str;
    },

    showAlert(message, variant) {
      if (!this.elements.alert) {
        return;
      }

      this.elements.alert.style.display = "block";
      this.elements.alert.className = `callout ${variant}`;
      this.elements.alert.textContent = message;
    },

    clearAlert() {
      if (!this.elements.alert) {
        return;
      }

      this.elements.alert.style.display = "none";
      this.elements.alert.className = "";
      this.elements.alert.textContent = "";
    },

    goToStep(step) {
      if (step < 1 || step > 3) return;
      this.currentStep = step;

      // Hide all content panels
      if (this.elements.hotContainer) this.elements.hotContainer.style.display = "none";
      if (this.elements.verifyContainer) this.elements.verifyContainer.style.display = "none";
      if (this.elements.importStep) this.elements.importStep.style.display = "none";

      // Show the active panel
      if (step === 1) {
        this.currentView = "spreadsheet";
        if (this.elements.hotContainer) this.elements.hotContainer.style.display = "";
        if (this.hot) this.hot.render();
      } else if (step === 2) {
        this.currentView = "verify";
        if (this.elements.verifyContainer) this.elements.verifyContainer.style.display = "";
        if (window.BulkTitleVerifyPanel && this.hot) {
          window.BulkTitleVerifyPanel.renderAll(
            this.hot.getSourceData(),
            this.rowMeta,
            this.lookups
          );
        }
      } else if (step === 3) {
        if (this.elements.importStep) this.elements.importStep.style.display = "";
        this.renderImportSummary();
      }

      // Update wizard step indicators
      if (this.elements.wizardSteps) {
        const steps = this.elements.wizardSteps.querySelectorAll(".wizard-step");
        steps.forEach((el) => {
          const s = parseInt(el.dataset.step, 10);
          el.classList.remove("is-active", "is-completed");
          if (s === step) el.classList.add("is-active");
          else if (s < step) el.classList.add("is-completed");
        });
      }

      // Update nav buttons
      if (this.elements.wizardBack) {
        this.elements.wizardBack.style.display = step > 1 ? "" : "none";
      }
      if (this.elements.wizardNext) {
        if (step === 3) {
          this.elements.wizardNext.style.display = "none";
        } else {
          this.elements.wizardNext.style.display = "";
          this.elements.wizardNext.textContent = step === 1
            ? "Next: Review \u2192"
            : "Next: Import \u2192";
        }
      }
    },

    renderImportSummary() {
      const panel = this.elements.importSummary;
      if (!panel) return;
      panel.textContent = "";

      let newCount = 0;
      let updateCount = 0;
      let errorCount = 0;
      let total = 0;

      for (let i = 0; i < this.rowMeta.length; i++) {
        const meta = this.rowMeta[i];
        if (!meta || !meta.imdb_id) continue;
        total++;
        if (meta.errors && meta.errors.length > 0) errorCount++;
        else if (meta.mode === "update") updateCount++;
        else newCount++;
      }

      const strong = document.createElement("strong");
      strong.textContent = total + " titles ready to import: ";
      panel.appendChild(strong);

      const newSpan = document.createElement("span");
      newSpan.style.color = "#a5d6a7";
      newSpan.textContent = newCount + " new";
      panel.appendChild(newSpan);
      panel.appendChild(document.createTextNode(", "));

      const updateSpan = document.createElement("span");
      updateSpan.style.color = "#90caf9";
      updateSpan.textContent = updateCount + " updates";
      panel.appendChild(updateSpan);

      if (errorCount > 0) {
        panel.appendChild(document.createTextNode(", "));
        const errSpan = document.createElement("span");
        errSpan.style.color = "#ef9a9a";
        errSpan.textContent = errorCount + " with errors";
        panel.appendChild(errSpan);
      }

      panel.appendChild(document.createElement("br"));
      const hint = document.createElement("small");
      hint.style.color = "#999";
      hint.textContent = 'Click "Import All Titles" to save to the database.';
      panel.appendChild(hint);
    },

    showSpreadsheetView() {
      this.goToStep(1);
    },

    showVerificationView() {
      this.goToStep(2);
    },

    handleLabelChangeForStudioId(rowIndex, oldValue, newValue) {
      if (!this.hot) {
        return;
      }

      const meta = this.rowMeta[rowIndex];
      if (meta && meta.mode === "update") {
        return;
      }

      const currentStudioId = this.hot.getDataAtRowProp(
        rowIndex,
        "__studio_id"
      );
      if (!currentStudioId) {
        return;
      }

      const labelPrefixes =
        this.lookups && this.lookups.label_prefixes
          ? this.lookups.label_prefixes
          : {};

      const newLabels = this.parseMultiselectToIds(newValue);
      const firstLabelId = newLabels.length > 0 ? String(newLabels[0]) : null;

      const newPrefix = firstLabelId
        ? labelPrefixes[firstLabelId] || "SD"
        : "SD";

      const underscorePos = currentStudioId.indexOf("_");
      if (underscorePos === -1) {
        return;
      }

      const abbreviation = currentStudioId.substring(underscorePos + 1);
      const updatedStudioId = newPrefix + "_" + abbreviation;

      if (updatedStudioId !== currentStudioId) {
        this.hot.setDataAtRowProp(
          rowIndex,
          "__studio_id",
          updatedStudioId,
          "auto_row_fetch"
        );
      }
    },

    updateStudioIdForDestination(rowIndex, newDestination) {
      if (!this.hot) {
        return;
      }

      const currentStudioId = this.hot.getDataAtRowProp(
        rowIndex,
        "__studio_id"
      );
      if (!currentStudioId) {
        return;
      }

      // Mirrors BulkTitleImportService::buildPreview: if labels are set,
      // their prefix wins and destination is ignored. Otherwise destination
      // picks BST vs SD.
      const currentLabels = this.parseMultiselectToIds(
        this.hot.getDataAtRowProp(rowIndex, "t_labels")
      );
      if (currentLabels.length > 0) {
        return;
      }

      const newPrefix = newDestination === "SD for BST" ? "BST" : "SD";

      const underscorePos = currentStudioId.indexOf("_");
      if (underscorePos === -1) {
        return;
      }

      const abbreviation = currentStudioId.substring(underscorePos + 1);
      const updatedStudioId = newPrefix + "_" + abbreviation;

      if (updatedStudioId !== currentStudioId) {
        this.hot.setDataAtRowProp(
          rowIndex,
          "__studio_id",
          updatedStudioId,
          "auto_row_fetch"
        );
      }
    },

    parseMultiselectToIds(value) {
      if (!value) {
        return [];
      }

      if (Array.isArray(value)) {
        return this.resolveLabelsToIds(value);
      }

      if (typeof value === "string") {
        var trimmed = value.trim();
        if (trimmed.startsWith("[")) {
          try {
            var parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) {
              return this.resolveLabelsToIds(parsed);
            }
          } catch (e) {}
        }
        return this.resolveLabelsToIds(
          trimmed
            .split(",")
            .map(function (s) {
              return s.trim();
            })
            .filter(function (s) {
              return s.length > 0;
            })
        );
      }

      return [];
    },

    resolveLabelsToIds(entries) {
      if (!entries || entries.length === 0) {
        return [];
      }

      var labelOptions =
        this.lookups && Array.isArray(this.lookups.labels)
          ? this.lookups.labels
          : [];

      var nameToId = {};
      labelOptions.forEach(function (opt) {
        if (opt && opt.label && opt.value !== undefined) {
          nameToId[String(opt.label).toLowerCase()] = opt.value;
        }
      });

      var ids = [];
      entries.forEach(function (entry) {
        var raw = String(entry).trim();
        if (/^\d+$/.test(raw)) {
          ids.push(Number(raw));
          return;
        }
        var mapped = nameToId[raw.toLowerCase()];
        if (mapped !== undefined) {
          ids.push(mapped);
        }
      });

      return ids;
    },

    destroyHot() {
      if (this.hot) {
        this.hot.destroy();
        this.hot = null;
      }

      if (this.hotIframe && this.hotIframe.contentWindow) {
        this.hotIframe.contentWindow.__bulkTitleHotInstance = null;
      }

      this.rowMeta = [];
      this.pendingRowFetchTokens = {};
    },
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      BulkTitleImport.init();
    });
  } else {
    BulkTitleImport.init();
  }
})();
